import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import DatetimePicker from 'vuetify-datetime-picker'
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify)
Vue.use(DatetimePicker)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // primary: '#4caf50',
        primary: '#2196F3',
        secondary: '#4caf50',
        tertiary: '#495057',
        accent: '#82B1FF',
        error: '#f55a4e',
        info: '#00d3ee',
        success: '#5cb860',
        warning: '#ffa21a',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { es },
    current: 'es',
  },
})
